function Loading() {
  return (
    <div className="modal">
      <div className="myContainer">Loading...</div>
    </div>
  );
}

export default Loading;
